import type { Frame, FrameVariant } from "@/types/dragon-tiles";

const VISIBLE_CHARACTER = /[^\p{White_Space}\p{Cc}\p{Cf}\p{Mn}]/u;

export function isBlankText(text: string | undefined): boolean {
  return !VISIBLE_CHARACTER.test(text ?? "");
}

function hasEmailBody(variant: FrameVariant): boolean {
  return Boolean(variant.content_text) || Boolean(variant.content_plaintext);
}

export function frameNeedsSubjectLine(frame: Frame): boolean {
  const emailVariant = frame.frame_variants.find(
    (variant) => variant.medium === "email" && hasEmailBody(variant),
  );
  return (
    emailVariant !== undefined && isBlankText(emailVariant.config?.subject_line)
  );
}
